
import { NoseurObject } from "@rivtn/noseur";

export type Subscription = (...data: any) => any;
export type SecondaryDataSubscription = (secondaryData: NoseurObject<any>) => void;

// TODO move to @rivtn/noseur
// TODO subscribe return key, so can unsubscribe by key
export const Subscriber = {
    
    __subscriptions: {} as NoseurObject<Subscription[]>,

    subscribe: (key: string, subscription: Subscription) => {
        if (!(key in Subscriber.__subscriptions)) Subscriber.__subscriptions[key] = [] as Subscription[];
        if (Subscriber.__subscriptions[key].includes(subscription)) return;
        Subscriber.__subscriptions[key].push(subscription);
    },

    unSubscribe: (key: string, subscription: Subscription) => {
        if (!(key in Subscriber.__subscriptions)) return;
        const index = Subscriber.__subscriptions[key].indexOf(subscription);
        if (index > -1) Subscriber.__subscriptions[key].splice(index, 1);
    },

    publish(key: string, ...data: any) {
        if (!(key in Subscriber.__subscriptions)) return;
        Subscriber.__subscriptions[key].forEach(subscription => subscription(...data));
    },

    subscriptions: (key?: string) => key ? Subscriber.__subscriptions[key] : Subscriber.__subscriptions,
    
    clearSubscriptions: (key?: string) => key ? ((key in Subscriber.__subscriptions) ? delete Subscriber.__subscriptions[key] : undefined) : Subscriber.__subscriptions = {},

}

